//--------------------------------------------------------------------------------
//
// App support
//
//--------------------------------------------------------------------------------

import { vdInit } from "./video";
import { pxInit, onPxShow, onPxSubmit, onPxDone } from "./px";

const TOKEN_NAME = "aio-token";
const AGREE_NAME = "aio-agree";

let config = null;

//--------------------------------------------------------------------------------
//
// runApp
//
//--------------------------------------------------------------------------------

export async function runApp(configSetup) // isMobile, touchSetup=null)
{
    config = configSetup;
 
    const token = await getToken();
    const agree = await checkAgree();

    const pathname = window.location.pathname;

    const apiURL = process.env.API_URL;
    const pxrURL = process.env.PXR_URL;
    const webURL = process.env.WEB_URL;
    const env    = process.env.ENVIRONMENT;

    if (apiURL == null || pxrURL == null || webURL == null || env == null) {
        console.warning("WARNING: Environment is not configured correctly.");
    }

    const node = document.getElementById("root");
    const flags = {
        apiURL,   pxrURL, webURL, env,
        pathname, agree, token,
        isMobile: config.isMobile,
    };
    const app = config.elmApp.init({ node, flags });

    setupPorts(app);
    return app;
}

//--------------------------------------------------------------------------------

export function usePayments(app) {
    app.ports.pxShow.subscribe(onPxShow(app));
    app.ports.pxSubmit.subscribe(onPxSubmit(app));
    pxInit();
}


function setupPorts(app)
{
    //
    // TOKEN
    //
    app.ports.clearToken.subscribe(onClearToken);
    app.ports.setToken.subscribe(onSetToken);
    app.ports.setAgree.subscribe(setAgree);

    //
    // WEB
    // 
    app.ports.clipboard.subscribe(onClipboard);
    // app.ports.focus.subscribe(onFocus);
    app.ports.scrollTo.subscribe(onScrollTo);
    // app.ports.scrollToFirstChild.subscribe(onScrollToFirstChild);
 
    //
    // Video playback
    //
    // app.ports.play.subscribe(play(app));
    // app.ports.playFwd.subscribe(playFwd(app));
    // app.ports.playRev.subscribe(playRev(app));
    // app.ports.playOff.subscribe(playOff(app));
    // app.ports.playPos.subscribe(playPos(app));
    //
    vdInit(app);
}

//--------------------------------------------------------------------------------

async function getToken() {
    // if (!!window.mobileLayer) {
    //     console.log("--- getToken mob");
    //     const getToken = window.mobileLater.getToken;
    //     return await getToken(TOKEN_NAME);

    if (config && config.getToken) {
        const getToken = config.getToken;
        return ((await getToken(TOKEN_NAME)) || "");
    } else {
        const usp     = new URLSearchParams(window.location.search);
        const token1  = getStore(TOKEN_NAME);
        const token2  = usp.get(TOKEN_NAME);
        return token1 || token2 || "";
    }
}

async function checkAgree() {
    if (config && config.getToken) {
        const getToken = config.getToken;
        const value = await getToken(AGREE_NAME)
        return value || "no";
    } else {
        return getStore(AGREE_NAME) || "no";
    }
}

// function cookieString(value, date)
// {   const d = date.toUTCString();
//     return "token=" + value + "; " + "expires=" + d + "; "
//         + "domain=onlymusicapp.com; " + "path=/;" + "SameSite=Strict;";
// }

export function getStore(name)
{
    return window.localStorage.getItem(name)
}

export async function onSetToken(value)
{
    //
    // Set local storage for returning
    // 
    window.localStorage.setItem(TOKEN_NAME, value);

    // if (!!window.mobileLayer) {
    //     const setToken = window.mobileLayer.setToken;
    //     await setToken(TOKEN_NAME, value);
    // }

    if (config && config.setToken) {
        const setToken = config.setToken;
        await setToken(TOKEN_NAME, value);
    }

    // //
    // // Set cookie for media access
    // //
    // const now = new Date();
    // const d   = new Date(now.getFullYear()+1, now.getMonth(), now.getDay());
    // const s   = cookieString(value, d);
    // document.cookie = s;
}

export async function onClearToken()
{
    const value = "";
    window.localStorage.setItem(TOKEN_NAME, value);

    // if (!!window.mobileLayer) {
    //     const clearToken = window.mobileLayer.setToken;
    //     await clearToken(TOKEN_NAME, value);
    // }

    if (config && config.setToken) {
        const clearToken = config.setToken;
        await clearToken(TOKEN_NAME, value);
    }

    // // Clear media access cookie
    // const d = new Date(1970, 1, 1);
    // const s = cookieString(value, d);
    // document.cookie = s;
}

async function setAgree()
{
    const yes = "yes";

    window.localStorage.setItem(AGREE_NAME, yes);

    if (config && config.setToken) {
        const setToken = config.setToken;
        await setToken(AGREE_NAME, yes);
    }
}

function onClipboard(text)
{
    try {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text);
        }
    } catch (err) {
    }
}

// function onFocus(label)
// {
//     requestAnimationFrame(function() {
//         const node = document.getElementById(label);
//         if (node) {
//             node.focus();
//         }
//     });
// }

function onScrollTo(label)
{
    requestAnimationFrame(function() {
        const node = document.getElementById(label);
        if (node) {
            node.scrollIntoView();
        }
    });
}

function onScrollToFirstChild(label)
{
    requestAnimationFrame(function() {
        const node = document.getElementById(label);
        if (node) {
            node.firstChild.scrollIntoView();
        }
    });
}

//--------------------------------------------------------------------------------
// function onClipPaste(app) {
//     return function() {
//         console.log("--- onClipPaste inner");
//         if (navigator.clipboard) {
//             console.log("--- onClipPaste n.cb present");
//             navigator.clipboard
//                 .writeText("Hello there!!")
//                 .then(
//                     success => console.log("--- onClipPaste SUCCESS:", success),
//                     err => console.log("--- onClipPaste FAIL:", err)
//                 );
//         } else {
//             console.log("--- onClipPaste n.cb NOT FOUND");
//         }
//     }
// }
//--------------------------------------------------------------------------------
// function touchSetup(app, node) {
//   console.log(">>> touchSetup");
//   node.addEventListener("touchstart",   onTouchStart,   false);
//   node.addEventListener("touchmove",    onTouchMove,    false);
//   node.addEventListener("touchend",     onTouchEnd,     false);
//   node.addEventListener("touchcancel",  onTouchCancel,  false);
//   console.log("<<< touchSetup");
// }
// function onTouchStart(evt)  { evt.preventDefault(); console.log("--- onTouchStart:",  evt); }
// function onTouchMove(evt)   { evt.preventDefault(); console.log("--- onTouchMove:",   evt); }
// function onTouchEnd(evt)    { evt.preventDefault(); console.log("--- onTouchEnd:",    evt); }
// function onTouchCancel(evt) { evt.preventDefault(); console.log("--- onTouchCancel:", evt); }
//--------------------------------------------------------------------------------
